import { render, staticRenderFns } from "./OrderFulfillmentsReport.vue?vue&type=template&id=4d068831"
import script from "./OrderFulfillmentsReport.vue?vue&type=script&lang=js"
export * from "./OrderFulfillmentsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports